<template>
  <div class="changepwd">
    <div class="content">
      <el-form>
        <el-form-item label="旧密码：" label-width="100px">
          <el-input
            size="mini"
            maxlength="20"
            @input="emptyfn"
            type="password"
            v-model="oldPwd"
            show-password
            placeholder="请输入旧密码"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="新密码：" label-width="100px">
          <el-input
            size="mini"
            maxlength="20"
            @input="emptyfn"
            type="password"
            v-model="newPwd"
            show-password
            placeholder="请输入新密码"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="确认新密码：" label-width="100px">
          <el-input
            size="mini"
            maxlength="20"
            @input="emptyfn"
            type="password"
            v-model="newPwdVerify"
            show-password
            placeholder="请输入新密码"
          >
          </el-input>
        </el-form-item>
      </el-form>
      <div class="btnn">
        <el-button
          type="primary"
          :disabled="disabledflag"
          @click="changeSub"
          size="mini"
          >确认修改</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { getUserName } from "../../utils/auth";
import { userChangePassword } from "@/api/userApi";
export default {
  name: "changepwd",
  data() {
    return {
      disabledflag: true,
      newPwdVerify: "",
      newPwd: "",
      oldPwd: "",
    };
  },
  methods: {
    async userChangePassword() {
      var userName = getUserName();
      var res = await userChangePassword({
        userName,
        oldPassword: this.oldPwd,
        newPassword: this.newPwd,
      });

      return res;
    },
    emptyfn() {
      if (this.oldPwd == "" || this.newPwdVerify == "" || this.newPwd == "") {
        this.disabledflag = true;
      } else {
        this.disabledflag = false;
      }
    },
    changeSub() {
      if (this.newPwdVerify != this.newPwd) {
        this.$alert("两次密码输入不一致", "密码错误", {
          type: "error",
          confirmButtonText: "知道了",
        });
      } else {
        this.userChangePassword().then((res) => {
          if (res.data.code == 1000) {
            this.$message({
              type: "success",
              message: "密码修改成功",
              showClose: true,
            });
            this.$router.push("/");
          } else {
            this.$alert("旧密码输入错误", "密码错误", {
              type: "error",
              confirmButtonText: "知道了",
            });
            //   this.$message.error( res.data.msg)
          }
        });
      }
    },
  },
};
</script>

<style lang="less">
.changepwd {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  .btnn {
    text-align: center;
    margin-top: 30px;
  }
  .content {
    // width: ;
    label {
      text-align: right;
    }
    .el-form-item {
      display: flex;
      text-align: center;
      margin: 0;
      .el-form-item__content {
        margin-left: 0 !important;
      }
    }
  }
}
</style>
